const toolChildren = [ // to "get" which "child" of each token is the response of the "requested tool"
  { name: 'nakdan', fitTask: (task) => task.endsWith('nakdan'), childInAll: true }, // covers 'quicknakdan' (for example)
  { name: 'abbreviation', fitTask: (task) => task.startsWith('abb'), childInAll: false } // covers 'abbrexp' (for example)
]

export function handleTokenizationJson(response, requestOptions) { // the "request options" we need are "fixed" (for
                                                            // the "parent function", which sent the request)
  // console.log('checking for tokenization-response structure...')
  const toolChildObj = toolChildren.find(tc => tc.fitTask(requestOptions.task))
  const toolChildName = toolChildObj.name
  if (!(Array.isArray(response.data)) && Object.prototype.hasOwnProperty.call(response.data, 'data')
      && Array.isArray(response.data.data) && response.data.data.length
      && (!(toolChildObj.childInAll) || response.data.data.every(t => Object.prototype.hasOwnProperty.call(t, toolChildName)))) {
    // console.log('tokenization-response structure detected...')
    response.data = response.data.data.map(t => {
      if (requestOptions.task === 'quicknakdan') return t.nakdan // response is just an array of STRINGS
      let classicOptions = []
      let formStrings = []
      if (!(toolChildObj.childInAll) /* currently ONLY "abbreviation" */ && !(Object.prototype.hasOwnProperty.call(t, toolChildName))) {
        t[toolChildName] = { // designed for tokens of abbreviation tool with no "child field" in token b/c "not an abbreviation"
          sep: t.sep,
          word: t.pStr || t.str,
          options: []
        }
      }
      const toolChild = t[toolChildName]
      toolChild.options.forEach(jsonOption => {
        if (requestOptions.addmorph) {
          const existingFormStringIndex = formStrings.indexOf(jsonOption.w)
          if (existingFormStringIndex === -1) {
            classicOptions.push([
              jsonOption.w, [[jsonOption.morph, jsonOption.lex]], !(!(jsonOption.fMahDagesh))
            ])
            formStrings.push(jsonOption.w)
          } else {
            let sameFormStringOption = classicOptions[existingFormStringIndex]
            // (no longer possible now that even ONE morph is put in an array) if (!(Array.isArray(sameFormStringOption[1][0]))) sameFormStringOption[1] = [sameFormStringOption[1]]
            sameFormStringOption[1].push([jsonOption.morph, jsonOption.lex])
          }
        } else classicOptions.push(typeof jsonOption === 'string' ? jsonOption : jsonOption.w) // options are arrays only if there's morph
      })
      // if (t === response.data.data[6]) console.log(classicOptions)
      return Object.assign(toolChild, { options: classicOptions })
    })
  }
}
